module.exports = __webpack_public_path__ + "static/media/frizo-app.3f5c1515.png";